<template>
  <div class="payment-method">
    <h2>{{ $t('W2P_RECEIPTS_PAYMENT_METHOD') }}</h2>
    <div class="options-container">
      <div
        @keydown.enter="setPaymentMethod('creditCard')"
        tabIndex="0"
        class="option-tile"
        :class="{ selected: selectedOption === 'creditCard' }"
        @click="setPaymentMethod('creditCard')"
        v-if="isPaymentMethodAvailable('creditCard')"
      >
        <div class="option-icon" aria-hidden="true">
          <input
            tabindex="-1"
            class="option-radio"
            name="creditCard"
            type="radio"
            value="creditCard"
            v-model="selectedOption"
          />
          <img :src="require(`@/assets/images/letters/pay/credit-card.svg`)" />
        </div>
        <div class="option-name">
          <span>{{ $t('W2P_CREDIT_CARD') }}</span>
        </div>
      </div>
      <div
        @keydown.enter="setPaymentMethod('invoice')"
        tabIndex="0"
        class="option-tile"
        :class="{
          selected: selectedOption === 'invoice',
          disabled: disableInvoice
        }"
        @click="setPaymentMethod('invoice')"
        v-if="isPaymentMethodAvailable('invoice')"
      >
        <input
          tabindex="-1"
          class="option-radio"
          name="invoice"
          type="radio"
          value="invoice"
          v-model="selectedOption"
        />
        <div class="option-icon" aria-hidden="true">
          <img
            :src="
              require(`@/assets/images/letters/pay/${
                disableInvoice ? 'invoice-disabled' : 'invoice'
              }.svg`)
            "
          />
        </div>
        <div class="option-name">
          <span>{{ $t('INVOICE') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  data: () => ({
    selectedOption: 'none',
    availablePaymentMethods: []
  }),
  computed: {
    ...mapState('letter/pay', ['paymentMethod', 'contactInformation']),
    disableInvoice() {
      const { customer } = this.contactInformation
      return (
        this.selectedOption === 'invoice' &&
        (!customer || (customer && !customer.customerNumber))
      )
    }
  },
  beforeMount() {
    this.selectedOption = this.paymentMethod
  },
  mounted() {
    this.$store
      .dispatch('letter/pay/getPaymentMethods')
      .then(res => {
        this.availablePaymentMethods = res.data.availablePaymentMethods.map(
          method => method.paymentMethodId
        )
      })
      .catch(err => {})
  },
  methods: {
    ...mapMutations('letter/pay', ['SET_PAYMENT_METHOD']),
    setPaymentMethod(option) {
      this.selectedOption = option
      this.SET_PAYMENT_METHOD(option)
    },
    isPaymentMethodAvailable(method) {
      const paymentMethods = {
        creditCard: 'CARD',
        invoice: 'INVOICE'
      }

      return this.availablePaymentMethods.includes(paymentMethods[method])
    }
  }
}
</script>

<style lang="scss" scoped>
.payment-method {
  margin: 4.8rem 0;
}

.option-tile {
  border: solid 0.01em $gray200;
  cursor: pointer;
  &:hover {
    border: 0.01rem solid $blue700;
    background-color: $blue50;
  }
}

.option-icon {
  padding: 2.4rem 1.6rem 1.7rem;

  img {
    width: 100%;
  }
}

.option-name {
  padding: 0 1.6rem 2.4rem;
  text-align: center;
}

.options-container {
  display: grid;
  grid-template-columns: 17rem 17rem 17rem;
  grid-gap: 1em;
  justify-items: center;
  margin: 2.4rem 0;
}

.option-radio {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.option-tile.selected {
  border-style: solid;
  border-width: 0.05em;
  border-bottom-width: 0.3em;
  border-color: $blue700;
  background-color: $blue50;

  &.disabled {
    border-color: $gray200;
    background-color: $gray50;
  }
}

@media screen and (max-width: 50em) {
  .option-title {
    display: unset;
  }

  .option-tile {
    display: flex;
  }

  .option-name {
    padding: unset;
    text-align: left;
    margin: auto 0;
  }

  .options-container {
    display: block;

    > * {
      margin-bottom: 1.6rem;
    }
  }
}
</style>
